import axios from '../server'
import store from '../store'
import { decryptAES } from '../utils/crypto';
import { GAME_ID_ASCII } from '../enum/const'

export const getConfig = params => axios.post(`${ store.state.gameSource === 'cn' ? '/webapicn' : '' }/webapi/get_config`, params)
export const sendCode = params => axios.post(`${ store.state.gameSource === 'cn' ? '/webapicn' : '' }/webapi/send_code`, params)
export const sendCodeToParent = params => axios.post(`${ store.state.gameSource === 'cn' ? '/webapicn' : '' }/webapi/send_code_to_parent`, params)
export const login = params => axios.post(`${ store.state.gameSource === 'cn' ? '/webapicn' : '' }/webapi/login`, params)
export const passportSocialLogin = params => axios.post(`${ store.state.gameSource === 'cn' ? '/webapicn' : '' }/webapi/social_login`, params)

export const getJson = url => axios.get(url, {})

export const socialLogin = params => axios.post('/gameApi/?action=social_login', params)

export const webSocialLogin = params => axios.post('/api/account/social_login', params)

export const oauthGetUidList = params => axios.post('/api/account/uid_list', params)

export const oauthGetUserInfo = params => {
  return new Promise((resolve, reject) => {
    const preAsc = GAME_ID_ASCII[params.game_id]
    const url = preAsc ? '/api/account/store/u' : '/api/account/store/user'
    axios.post(url, params).then(res => {
      if (typeof res === 'string') {
        try {
          res = JSON.parse(decryptAES(res, preAsc))
        } catch (error) {
          console.log(error)
        }
      }
      resolve(res)
    }).catch(err => reject(err))
  })
}

export const pushCodeToServer = params => axios.get(`ame/${params.g}/do`, params)
export const pushCodeToOpenApi = params => axios.get('/openapi/set_social_token', params)

// 使用AME 兼容老的/ame
export const ameDo = params => axios.get('AME/do', params)
